
















































































import { ScreenSize } from '@/main/components/constants';
import _ from 'lodash';
import { ElMessageBoxOptions } from 'element-ui/types/message-box';
import { ApiNotificationOption, getMessageType, showAlert } from '@/main/utils/notifications';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { ENTITY, TABLE_DATA } from '@/main/store/listEditTypes';
import { types } from '@/modules/servis/zakazka/store/types';
import ZakazkaSelect from '@/modules/servis/zakazka/components/Select.vue';
import { mapActionsDvm, mapMutationsDvm } from '@/main/pages';
import { BUTTON_TYPES_ENUM } from '@/main/components/@types/button';
import { PageMode } from '@/main/utils/pageMode';
import { DokladNaplnFakturaci } from '@/modules/uctenky/fakturace/constants';
import { openEdit } from '@/main/router/routerPath';

import { apiProvider as zakazkaApiProvider } from '@/modules/servis/zakazka/api';

import { SignalRConnection, SignalRResponsesEnum } from '#services/signalR';
import { DmsBaseComponent } from '#components/dms/common/base';

import DropButtons from './DropButtons.vue';

import { store } from '../store/edit';
import { getNextStavZakazka, getPrevStavZakazka, getStavZakazka } from '../utils';
import { Fakturace } from '../../../uctenky/fakturace';
import { DZM_TYPE, MIO_TYPE, SDAKontext, ZAKAZKA_DRUH, ZAKAZKA_STAV, SAGA_2_POL, SAGA_2_HLAV, SAGA_2_KOM, MENU_CODE, BILLING_OPERATION_CODE, RELEASE_ORDER } from '../constants';


export default DmsBaseComponent.extend({
	name: 'WorkflowButtons',
	components: {
		ZakazkaSelect,
		DropButtons,

	},
	props: {
		changeTyp: {
			type: String,
			default: '',
		},
		fakturaceMethod: { type: Function },
		storeUri: { type: String, default: null, required: true },
	},
	data() {
		return {
			screenSize: ScreenSize.TABLET,
			windowWidth: window.innerWidth,
			workflowButton: [
				{
					labelKey: '' as string | null,
					click: null as Function | null,
					class: '' as string | null,
					disable: '' as string | boolean | null,
					exist: true as boolean | string | null,
					icon: '' as string | null,
				},

			],
			DZM_TYPE,
			MIO_TYPE,
			signalR: {} as SignalRConnection,
			dzmType: DZM_TYPE.ZAVADY_NEODSTRANENY,
			dzmDuvod: '',
			sdaRadio: [] as any,
			sdaType: 0,
			mioType: MIO_TYPE.AUTO,
			mio: {
				nejenZakazkaNr: false,
				mazatNeodeslane: true,
				message: '',
				messagePerm: '',
			},
			sda: {
				popis: '',
				akce: '',
				sdaKontext: SDAKontext.eUvolneniZakazky,
				garancniZakazka: false,
			},
			customDialog: {
				dialogMessage: '',
				showDialog: false,
				showYes: false,
				showOk: false,
				showNo: false,
				showCancel: false,
				dzm: false,
				sda: false,
				mio: false,
				modalCloseOnClick: true,
			},
			connectionAck: null as any,
			connectionZakazkaHub: null as any,
			transactionId: '',
			SignalRResponsesEnum,

		};
	},
	watch: {
		dzmType(newVal) {
			if (newVal === 3) {
				this.dzmDuvod = '';
			}
		},
		mioZakazkaId(newVal) {
			this.mio.mazatNeodeslane = !!newVal;
		},
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				zakazka: `${this.storeUri}/${types.mutations.ZAKAZKA_MIO_SELECT_MAPPER}`,
			};
		},
		garanceKulance(): boolean {
			return this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE || this.ZakazkaDruh === ZAKAZKA_DRUH.KULANCE;
		},
		isParitalInvoiceGenrated(): boolean {
			return (this.IsPartialInvoiced && getStavZakazka(this.edit) === ZAKAZKA_STAV.UVOLNENA) ?? false;
		},
		isOEMPartyBilled(): boolean {
			return (this.IsOEMPartyBilled && getStavZakazka(this.edit) === ZAKAZKA_STAV.UVOLNENA) ?? false;
		},
		dzmMsg(): string {
			return this.LocalizeChyboveHlasky(`dzmWriteSt${this.dzmType}`);
		},
		dialogTitle(): string {
			if (this.customDialog.mio) {
				return this.LocalizeFormular('dlgMio');
			}
			if (this.customDialog.sda) {
				return this.LocalizeFormular('dlgSDA');
			}
			if (this.customDialog.dzm) {
				return this.LocalizeFormular('dlgDZM');
			}
			return '';
		},
		isUvolnena(): boolean {
			return getStavZakazka(this.edit) === ZAKAZKA_STAV.UVOLNENA;
		},
		isChangeToKulanceEnabled(): boolean {
			return (
				getStavZakazka(this.edit) === ZAKAZKA_STAV.OTEVRENA
				&& (this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA || this.ZakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA)
			);
		},
		isChangeToGaranceEnabled(): boolean {
			return (

				getStavZakazka(this.edit) === ZAKAZKA_STAV.OTEVRENA && this.ZakazkaDruh === ZAKAZKA_DRUH.KULANCE && !this.Saga2Prp && (this.toGarance || this.toInterni)
			);
		},
		isChangeTypeEnabled(): boolean {
			return this.isChangeToKulanceEnabled || this.isChangeToGaranceEnabled;
		},
		zakazkaMainForm(): any {
			return this.$parent.$parent.$parent.$refs.mainForm;
		},
		disableNextStav(): boolean {
			if(_.isUndefined(this.hasBillingPermission)) {
				 return true;
			}
			else {
				if (this.IsWatchlisted === true) return true;
				return !this.nextStav() || (this.isUvolnena && !this.CanFakturace) || this.IsJoblistApproved === 0;
			}
		},
		hasBillingPermission():boolean {
			if(getStavZakazka(this.edit) === ZAKAZKA_STAV.UVOLNENA) {
				let result= this.loggedUser.UserMenu.find((menu: any) => menu.MenuCode === MENU_CODE
				&& menu.OperationCode.find((code: string) => code === BILLING_OPERATION_CODE));
				return result;
			}
			return true;
		},
		wfButtons(): object {
			return this.workflowButton
				.filter((item) => !_.isNil((item.labelKey && item.exist) || (item.icon && item.exist)))
				.map((item) => ({
					labelKey: item.labelKey,
					click: item.click,
					exist:	item.exist,
					disable: item.disable,
					class:	item.class,
					icon:	item.icon,
				}));
		},
		isTabletEnabled(): boolean {
			return this.windowWidth > this.screenSize;
		},
	},
	methods: {
		...mapMutationsDvm(store.mutations),
		...mapActionsDvm(store.actions),
		async clickNextStav() {
			if (getStavZakazka(this.edit) + 1 === ZAKAZKA_STAV.UVOLNENA) {
				await this.changeToNext();
			} else {
				console.log('Not implemented yet');
			}
		},
		nextStav() {
			// TODO: - pro disabled - return uzivatel nema pravo na O_DOKLAD
			return this.isUvolnena ? 'cmdFakt' : getNextStavZakazka(this.edit, this.dmsSys.IsPreparationActivePrp);
		},
		prevStav() {
			return getPrevStavZakazka(this.edit);
		},
		async changeToNextStateClick() {
			const isValid = await this.zakazkaMainForm.validate();
			if (isValid) {
				let messageText = '';
				let finishType = '';
				if (this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA || this.ZakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA) {
					messageText = this.LocalizeChyboveHlasky('ConfirmKulanc');
					finishType = ZAKAZKA_DRUH.KULANCE;
				} else if (this.ZakazkaDruh === ZAKAZKA_DRUH.KULANCE) {
					messageText = this.LocalizeChyboveHlasky('ConfirmChgZak');
					if (this.toGarance) {
						messageText = messageText.concat(` ${this.LocalizePopisostatni('Garance')}`);
					} else if (this.toInterni) {
						messageText = messageText.concat(` ${this.LocalizePopisostatni('InterniDilna')}`);
					}
					finishType = ZAKAZKA_DRUH.GARANCE;
				}
				const result = await this.showConfirm({
					message: messageText,
					options: {
						title: this.LocalizePopisostatni('CRMDotaz'),
						type: BUTTON_TYPES_ENUM.INFO,
						cancelButtonText: this.Localize('Ne'),
						confirmButtonText: this.Localize('Ano'),
					},
				});
				if (result) {
					if (finishType === ZAKAZKA_DRUH.KULANCE) {
						this.changeToKulance();
					} else if (finishType === ZAKAZKA_DRUH.GARANCE) {
						if (this.toGarance) {
							this.changeToGarance();
						} else if (this.toInterni) {
							this.changeToInterni();
						}
					}
				}
			}
		},
		async changeToNextState() {
			if (this.dmsSys.IsCommMode_IsDocConf_Prp) {
				if (!this.CustDocReminder
					&& this.validationRules!.CustDocReminder.required
					&& ![ZAKAZKA_STAV.NABIDKA, ZAKAZKA_STAV.V_PRIPRAVE].includes(this.Stav!)) {
					this.showErrorAlert({ message: 'IsCustinfoAlert' });
					return false;
				}
			}
			switch (getStavZakazka(this.edit)) {
				case ZAKAZKA_STAV.OTEVRENA:
				case ZAKAZKA_STAV.UVOLNENA:
					await this.changeToNext();
					break;
				case ZAKAZKA_STAV.V_PRIPRAVE:
					await this.prevodOtevrena();
					break;
				case ZAKAZKA_STAV.NABIDKA:
					await this.prevedNabidkuDoPripravy();
					if (this.dmsSys.GenerateQuotationPrp && this.dmsSys.IsPreparationActivePrp) {
						let DokladNaplnFakturacitype: DokladNaplnFakturaci = DokladNaplnFakturaci.QUICK_ESTIMATE;
						if ([ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.KULANCE].includes(this.ZakazkaDruh!)) {
							DokladNaplnFakturacitype = DokladNaplnFakturaci.QUICK_ESTIMATE;
							openEdit(Fakturace.name, PageMode.CREATE, {
								filter: {
									zakazkaId: this.ZakazkaId,
									dokladNaplnFakturaci: DokladNaplnFakturacitype,
									createdById: this.loggedUser.PracovnikData.PracovnikId,
								},
							});
						} else if ([ZAKAZKA_DRUH.PRODEJ_PULT, ZAKAZKA_DRUH.PRODEJ_ZBOZI].includes(this.ZakazkaDruh!)) {
							DokladNaplnFakturacitype = DokladNaplnFakturaci.SALE_QUOTE;
							openEdit(Fakturace.name, PageMode.CREATE, {
								filter: {
									zakazkaId: this.ZakazkaId,
									dokladNaplnFakturaci: DokladNaplnFakturacitype,
									createdById: this.loggedUser.PracovnikData.PracovnikId,
								},
							});
						}
					}
					if (!this.dmsSys.IsPreparationActivePrp) { 
						this.NabidkaPrp = false;
						await this.prevodOtevrena();
					}
					break;
				default:
					break;
			}
			return true;
		},
		changeToPrevState() {
			switch (getStavZakazka(this.edit)) {
				case ZAKAZKA_STAV.OTEVRENA:
				case ZAKAZKA_STAV.UVOLNENA:
				if(!this.Saga2Prp)
				{
					this.UvolnenaToOtevrena();
				}
				else
				{				
					this.showConfirm({
					message:  this.LocalizeChyboveHlasky('SagaCancelConfirmationMessage'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							distinguishCancelAndClose: true,
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
							dangerouslyUseHTMLString: true,
							callback: async (action) => {
								if (action === 'confirm') {
									this.IsOrderCancelInSaga = true;
									this.UvolnenaToOtevrena();
								}
								else if (action === 'cancel')
								{
									this.IsOrderCancelInSaga = false;
									this.UvolnenaToOtevrena();
								}
							}
						},
					});	
				}
				break;
				case ZAKAZKA_STAV.V_PRIPRAVE:
				default:
					break;
			}
		},
		async changeToNext() {
			if (this.isUvolnena) {
				this.fakturaceMethod(undefined, undefined,  true);
			} else {
				const isValid = await this.zakazkaMainForm.validate(true);
				if (isValid) {
					await this.uvolneni();
				}
			}
		},
		async uvolneni() {
			const startTime1 = performance.now();   
			this.startLoading();
			const { data: releaseOrderDataArray } = await zakazkaApiProvider.getReleaseOrderData(this.ZakazkaId!);
			const elapsed1 = performance.now() - startTime1; 
			this.endLoading();
			const releaseOrderData = releaseOrderDataArray && releaseOrderDataArray.length ? releaseOrderDataArray[0] : {};

			if ((this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA) && this.VozidloId != null && !this.IsCreditNoteProcessed && !this.IsPartialInvoice) {
				const confirmResult = await this.showConfirm({
					message: this.LocalizeChyboveHlasky('ConfirmContactInformation'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						showClose: false,
						confirmButtonText: this.Localize('Ano'),
						cancelButtonText: this.Localize('Ne'),
					},
				});
				if (!confirmResult) {
					return;
				}
			}
			if (this.dmsSys.WorkItemPrp && this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT) {
				if ((this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI || this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA) && this.VozidloId != null) { 
					if (releaseOrderDataArray && releaseOrderDataArray.length) {
						if (releaseOrderDataArray.every((x: any) => !x.OverAllLineItemCompletionStatus)) {
							this.showErrorAlert({ message: this.LocalizeChyboveHlasky('orderNotCompletedYet')});
							return;
						}
					}
				}
				if ((this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_ZBOZI || (this.ZakazkaDruh === ZAKAZKA_DRUH.PRODEJ_ZBOZI && this.VozidloId === null))
					&& this.ZakazkaDruh !== ZAKAZKA_DRUH.DILENSKA && this.IsAllItemLevelStatusEntered !== true
				&& this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('orderNotCompletedYet')});
					return;
				}
				if (!releaseOrderData.IsProformaCreated && this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND) {
					this.showErrorAlert({
						message: `${this.LocalizeChyboveHlasky('Err_Proforma')}`,
						localizeMessage: false,
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						options: { type: 'error' },
					});
					return;
				}
			}
			if (this.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_ZBOZI && this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND) {
				const kmStav = releaseOrderData.KmStav;
				if (kmStav === null || kmStav === undefined) {
					this.showErrorAlert({
						message: `${this.LocalizeChyboveHlasky('CreateZL')}`,
						localizeMessage: false,
						title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
						options: { type: 'error' },
					});
					return;
				}				
			}
			this.startLoading();
			const startTime2 = performance.now();
			const response = await this.signalR.mainCall('Uvolneni', this.edit);
			this.endLoading();
			await this.fetchTableData([SAGA_2_POL, SAGA_2_HLAV, SAGA_2_KOM]);
			const elapsed2 = performance.now() - startTime2; 
    		const seconds = parseFloat(((elapsed1 + elapsed2) / 1000).toFixed(2)); 
			await zakazkaApiProvider.logPerformance('OrderPrp', 'Order', RELEASE_ORDER, seconds);
			if (response) {
				const UserMessagesList = response.UserMessageList;
				if (UserMessagesList && UserMessagesList.length > 0) {
					const message = UserMessagesList.map((item: ApiNotificationOption) => item.Message).join('<br>');
					const alert = {
						title: UserMessagesList[0].Title,
						message,
						options: {
							type: getMessageType(UserMessagesList[0].Type),
						} as ElMessageBoxOptions,
					};
					await showAlert(alert);
				}
			}
			this.startLoading();
			await this.$store.dispatch(`${this.storeUri}/${ENTITY}`, { id: this.ZakazkaId, edit: this.pageMode === PageMode.EDIT });
			if (response && response.UvolneniDat) {
				response.UvolneniUsePredavaciProtokol = false; // TODO: predavaci protokol jeste neni implementovan
				if (!response.UvolneniUsePredavaciProtokol && !response.UvolneniDialog && response.CanFakturace) {
					if (response.UvolneniUnlockSaga) {
						this.fakturaceMethod(undefined, undefined,  true);
						await this.$store.dispatch(`${this.storeUri}/${ENTITY}`, { id: this.ZakazkaId, edit: this.pageMode === PageMode.EDIT });
					}
				} else if (response.CanFakturace && response.UvolneniUnlockSaga) {
					if(response.UvolneniUsePredavaciProtokol){
					const confirmResult = await this.showConfirm({
						message: this.LocalizeChyboveHlasky('TiskPredProt'),
						title: this.LocalizePopisostatni('CRMDotaz'),
						options: {
							showClose: false,
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
						},
					});
					if (!confirmResult) {
						this.endLoading();
						return;
					}	
					}
					if (response.UvolneniUsePredavaciProtokol) {
						// TODO: fakturace s typem predavaci protokol bude se predelavat v dms2
						// this.fakturaceMethod(DokladNaplnFakturaci.PREDAVACI_PROTOKOL);
					} else {
						this.fakturaceMethod(undefined, undefined,  true);
						await this.$store.dispatch(`${this.storeUri}/${ENTITY}`, { id: this.ZakazkaId, edit: this.pageMode === PageMode.EDIT });
					}
				}
			}
			this.endLoading();
		},
		async fetchTableData(this: any, tablesToFetch: string[] = Object.values(this.zakazkaTables)): Promise<any> {
            const tables: [string, any][] = tablesToFetch.map((item) => [item, item]);
            return Promise.all(tables.map(([key, value]) => this.$store.dispatch(`${this.storeUri}/${value}_${TABLE_DATA}`, { filter: this[`${value}Filter`] })));
        },
		async sendResponse(val: SignalRResponsesEnum) {
			this.customDialog.showDialog = false;
			this.startLoading();
			let error = false;
			if (this.customDialog.mio) {
				if (this.mioType === 4 || this.mio.nejenZakazkaNr) {
					// kdyz nemam zakzku presune me na vyber
					if (this.mioZakazkaIdNr) {
						// zkontoluj zakazku cislo jestli exituje kdyz ne smaze text, a da focus na vyber zakazky
						error = true;
						this.mio.message = this.mioZakazkaIdNr + this.LocalizeChyboveHlasky('NeniOpenZak');
					}
					if (this.mioZakazkaIdNr) {
						// pokacuj
					} else {
						error = true;
						this.mio.messagePerm = this.LocalizeChyboveHlasky('Nepravonasklad');
					}
				}
				if (!error) {
					if (this.mioType !== 4) {
						// check dilu na zakazce a odpis ND
						// kdyz nemam dily finish
						await this.signalR.acknowledgeCall(val, { Status: this.dzmType, Duvod: this.dzmDuvod });
						this.customDialog.dzm = false;
					}
				}
			} else if (this.customDialog.dzm) {
				await this.signalR.acknowledgeCall(val, { Status: this.dzmType, Duvod: this.dzmDuvod });
				this.customDialog.dzm = false;
			} else if (this.customDialog.sda) {
				await this.signalR.acknowledgeCall(val, this.sdaType);
				this.customDialog.sda = false;
				this.sdaRadio = [];
			} else {
				await this.signalR.acknowledgeCall(val);
			}
		},
	},
	async created() {
		this.signalR = new SignalRConnection('ZakazkaHub');
		await this.signalR.start();
	},
	async beforeDestroy() {
		await this.signalR.stop();
	},
	async mounted() {
		window.addEventListener('resize', () => {
			this.windowWidth = window.innerWidth;
		});


		this.workflowButton =			[
			{ labelKey: this.changeTyp, click: this.changeToNextStateClick, disable: !this.isChangeTypeEnabled, exist: this.changeTyp !== 'Kulance' ? this.changeTyp : null, class: 'btn-height', icon: 'icon-workflow' },
			{
				labelKey: this.prevStav(),
				click: this.changeToPrevState,
				disable: !this.prevStav() && !(this.garanceKulance && this.Saga2Prp),
				exist: true,
				class: 'btn-height',
				icon: 'icon-arrow-left-over',
			},
			{ labelKey: this.nextStav(), click: this.changeToNextState, disable: this.disableNextStav, exist: true, class: 'btn-height', icon: 'icon-arrow-right-over' },
		];


		// ---------
		// Call client methods from hub
		// ---------
		this.signalR.listenTo('ZobrazDialogAnoNeCancel', (message: string) => {
			this.endLoading();
			this.customDialog.showYes = true;
			this.customDialog.showOk = false;
			this.customDialog.showCancel = true;
			this.customDialog.showNo = true;
			this.customDialog.dialogMessage = message;
			this.customDialog.showDialog = true;
		});
		this.signalR.listenTo('ZobrazDialogAnoNe', (message: string) => {
			this.endLoading();
			this.customDialog.showYes = true;
			this.customDialog.showOk = false;
			this.customDialog.showCancel = false;
			this.customDialog.showNo = true;
			this.customDialog.dialogMessage = message;
			this.customDialog.showDialog = true;
			this.customDialog.modalCloseOnClick = false;
		});
		this.signalR.listenTo('ZobrazDialogOKCancel', (message: string) => {
			this.endLoading();
			this.customDialog.showYes = false;
			this.customDialog.showOk = true;
			this.customDialog.showCancel = false;
			this.customDialog.showNo = false;
			this.customDialog.dialogMessage = message;
			this.customDialog.showDialog = true;
		});
		this.signalR.listenTo('ZobrazDialogDZM', () => {
			this.endLoading();
			this.customDialog.showYes = false;
			this.customDialog.showOk = true;
			this.customDialog.showCancel = true;
			this.customDialog.showNo = false;
			this.customDialog.dialogMessage = '';
			this.customDialog.showDialog = true;
			this.customDialog.dzm = true;
			this.dzmType = 0;
			this.dzmDuvod = '';
		});
		this.signalR.listenTo('ZobrazDialogSDA', (message: any) => {
			const objMessage = JSON.parse(message);
			this.endLoading();
			this.customDialog.showYes = false;
			this.customDialog.showOk = true;
			this.customDialog.showCancel = true;
			this.customDialog.showNo = false;
			this.customDialog.dialogMessage = '';
			this.customDialog.showDialog = true;
			this.customDialog.sda = true;
			this.sda.popis = objMessage.popis;
			this.sda.akce = objMessage.akce;
			this.sda.sdaKontext = objMessage.sdaKontext;
			this.sda.garancniZakazka = objMessage.garancniZakazka;
			if (objMessage.sdaKontext === SDAKontext.eUvolneniZakazky && message.garancniZakazka) {
				this.sdaRadio.push('sdaStatus1');
			}
			if (objMessage.sdaKontext === SDAKontext.eAdministrace) {
				this.sdaRadio.push('sdaStatus2');
			}
			this.sdaRadio.push('sdaStatus3');
			if (objMessage.sdaKontext !== SDAKontext.eAdministrace) {
				this.sdaRadio.push('sdaStatus4');
			}
			if (objMessage.sdaKontext === SDAKontext.eUvolneniZakazky && !objMessage.garancniZakazka) {
				this.sdaRadio.push('sdaStatus5');
			}
		});
		this.signalR.listenTo('ZobrazDialogMio', (message: string) => {
			const objMessage = JSON.parse(message);
			this.endLoading();
			this.customDialog.showYes = false;
			this.customDialog.showOk = true;
			this.customDialog.showCancel = true;
			this.customDialog.showNo = false;
			this.customDialog.mio = true;
			this.customDialog.showDialog = true;
			this.mio.nejenZakazkaNr = objMessage;
		});
	},
});
